module.exports = "https://static.wmbcdn.com/uniweb/images/a397013dd5380cb2734a1d2c2d5f7b43.svg";